// src/plugins/realtime.ts
import type { App } from 'vue'
import { realtimeStream } from '@/utils/realtimeNotification.ts'

export default {
  install(app: App, options?: { autoConnect?: boolean }) {
    // 全局属性，方便在组件外访问
    app.config.globalProperties.$realtime = {
        connect: () => realtimeStream.connect(),
      disconnect: () => realtimeStream.disconnect(),
      isConnected: realtimeStream.isConnected,
      onRefresh: realtimeStream.onRefresh.bind(realtimeStream)
    }
    
    // 自动连接（默认开启）
    const autoConnect = options?.autoConnect !== false
    if (autoConnect) {
      // 确保在 DOM 加载完成后连接
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          realtimeStream.connect()
        })
      } else {
        realtimeStream.connect()
      }
    }
  }
}